import { component } from 'picoapp'

export default component((node, ctx) => {
    const { id, blogHandle, totalCount, limit } = JSON.parse(node.dataset.config)
    const output = node.querySelector('[data-articles-grid]')
    let loops = Math.ceil(totalCount / limit)

    let allArticles = []

    const getAllArticles = () => {
        fetch(`/admin/api/2020-07/blogs/${id}/articles.json?limit=${limit}`)
            .then((r) => r.json())
            .then((data) => {
                const articles = data.articles
                allArticles = articles
                ctx.emit('articles:loaded')
            })
    }
    getAllArticles()

    ctx.on('articles:loaded', () => {
        const renderArticles = (articles) => {
            return articles
                .map((a) => {
                    return `
                    <div class="blog__item">
                        <a href="/blogs/${blogHandle}/${a.handle}" class="blog__grid__item--link"></a>
                    
                        <figure class="blog__item--image">
                            <img src="${a.image.src}" />
                        </figure>
                    
                        <h3 class="blog__item--title">${a.title}</h3>
                    
                        <article class="blog__item--excerpt">
                                ${a.summary_html}
                        </article>
                    
                        <a href="/blogs/${blogHandle}/${a.handle}" class="blog__item--read-more uppercase underline">Read more</a>
                    </div>
                `
                })
                .join('')
        }

        output.innerHTML = renderArticles(allArticles)
    })
})
